<svg
  width="21"
  height="20"
  viewBox="0 0 21 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.3277 1.6665C5.73266 1.6665 1.99432 5.40484 1.99432 9.99984C1.99432 14.5948 5.73266 18.3332 10.3277 18.3332C14.9227 18.3332 18.661 14.5948 18.661 9.99984C18.661 5.40484 14.9227 1.6665 10.3277 1.6665ZM10.3277 16.6665C6.65182 16.6665 3.66099 13.6757 3.66099 9.99984C3.66099 6.324 6.65182 3.33317 10.3277 3.33317C14.0035 3.33317 16.9943 6.324 16.9943 9.99984C16.9943 13.6757 14.0035 16.6665 10.3277 16.6665Z"
    fill="currentColor"
  />
  <path
    d="M9.49432 9.1665H11.161V14.1665H9.49432V9.1665ZM9.49432 5.83317H11.161V7.49984H9.49432V5.83317Z"
    fill="currentColor"
  />
</svg>
